import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_logo-verizon-sm",
  "use": "svg_logo-verizon-sm-usage",
  "viewBox": "0 0 19 23",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 23\" id=\"svg_logo-verizon-sm\"><path d=\"M15.764 0 10.51 11.357l-3.644 7.877-3.644-7.877H0l5.255 11.357h3.22l5.255-11.357L18.985 0z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol